var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChevronUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 7 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.31024 0.150019C3.23949 0.120683 3.16192 0.104492 3.08057 0.104492C2.99921 0.104492 2.92164 0.120683 2.8509 0.150019C2.78013 0.179299 2.71383 0.222702 2.6563 0.280228L0.256302 2.68023C0.0219878 2.91454 0.0219878 3.29444 0.256302 3.52876C0.490617 3.76307 0.870516 3.76307 1.10483 3.52876L2.48057 2.15302V5.50449C2.48057 5.83586 2.7492 6.10449 3.08057 6.10449C3.41194 6.10449 3.68057 5.83586 3.68057 5.50449V2.15302L5.0563 3.52876C5.29062 3.76307 5.67052 3.76307 5.90483 3.52876C6.13914 3.29444 6.13914 2.91454 5.90483 2.68023L3.50483 0.280228C3.4473 0.222702 3.381 0.179299 3.31024 0.150019Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUp);
export default __webpack_public_path__ + "static/media/chevron-up.f6476034cdac76b6291843f69333859a.svg";
export { ForwardRef as ReactComponent };